import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react';
import { showErrorToast, showSuccessToast } from '../../../Toster';
import axiosPrivate from '../../../hooks/axiosPrivate';
import { BiEdit } from 'react-icons/bi';

export default function Circular({ circulars = [], fetchCircular }) {
  const [isOpen, setIsOpen] = useState(false);
  const [name, setName] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [selectedCircular, setSelectedCircular] = useState(null);

  const handleEdit = (circular) => {
    setIsEdit(true);
    setIsOpen(true);
    setName(circular.name);
    setSelectedCircular(circular);
  };

  const handleSubmit = () => {
    if (isEdit) {
      // Update logic here
      axiosPrivate
        .put(`circular/${selectedCircular?.id}`, { name })
        .then((res) => {
          if (res?.data?.success) {
            showSuccessToast(
              res?.data?.message || 'Circular updated successfully'
            );
            setIsOpen(false);
            setName('');
            fetchCircular();
          }else{
            showErrorToast(res?.data?.message);
          }
        })
        .catch((error) => {
          showErrorToast(error?.message);
        });
    } else {
      // Create logic here
      axiosPrivate
        .post('circular', { name })
        .then((res) => {
          if (res?.data?.success) {
            showSuccessToast(
              res?.data?.message || 'Circular created successfully'
            );
            setIsOpen(false);
            setName('');
            fetchCircular();
          } else {
            showErrorToast(res?.data?.message);
          }
        })
        .catch((error) => {
          showErrorToast(error?.data?.message || error?.message);
        });
    }
  };

  return (
    <>
      <Dialog
        header={isEdit ? `Update Circular` : `Create Circular`}
        visible={isOpen}
        onHide={() => {
          if (!isOpen) return;
          setIsOpen(false);
          setName('');
        }}
        style={{ maxHeight: '250px' }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            width: '100%',
            padding: '0 10px',
          }}
        >
          <div className=''>
            <label>
              Name<span className='required'>*</span>
            </label>
            <input
              type='text'
              className='form-control'
              placeholder='Enter Name'
              value={name}
              onChange={(event) => {
                setName(event.target.value);
              }}
            />
          </div>

          <div className='' style={{ textAlign: 'right' }}>
            <button
              onClick={handleSubmit}
              disabled={!name}
              className='btn btn-success ml-1'
            >
              {isEdit ? 'Update' : 'Create'}
            </button>
          </div>
        </div>
      </Dialog>
      <div className='card-header'>
        <strong className=''>Circulars</strong>
      </div>
      <div className='card'>
        <div className='col-12 submit-btn my-2'>
          <button
            // disabled={!selectedDealer || rateUpdating}
            type='submit'
            className='btn btn-primary ml-2'
            onClick={() => setIsOpen(true)}
          >
            Create
          </button>
        </div>

        <div className='table-container'>
          <table className='custom-table'>
            <thead>
              <tr>
                <th>
                  <label>Name</label>
                </th>
                <th>
                  <label>Action</label>
                </th>
              </tr>
            </thead>
            <tbody>
              {circulars?.map((circular, index) => (
                <tr key={circular.id}>
                  <td>
                    <label>{circular?.name}</label>
                  </td>
                  <td>
                    <BiEdit
                      onClick={() => handleEdit(circular)}
                      style={{ color: 'green' }}
                      size={18}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
